<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.frequencyData.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.frequencyData.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.frequencyData.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.frequencyData.totalWeight')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <div class="handle-box">
                    <!-- <el-date-picker
                            v-model="query.startDate"
                            type="date"
                            placeholder="开始日期"
                            class="handle-select mr10"
                            :picker-options="pickerOptions0"
                        >
                        </el-date-picker>
                        <el-date-picker
                            v-model="query.endDate"
                            type="date"
                            placeholder="结束日期"
                            class="handle-select mr10"
                            :picker-options="pickerOptions0"
                        >
                        </el-date-picker>-->
                    <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="$t('pages.frequencyData.rangeSeparator')" :start-placeholder="$t('pages.frequencyData.startDate')" :end-placeholder="$t('pages.frequencyData.endDate')" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>
                    <el-select v-model="query.balanceId" :placeholder="$t('pages.frequencyData.scale')" class="handle-select mr10" @change="changeBalance">
                        <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                    </el-select>

                    <el-select v-model="query.Frequency" :placeholder="$t('pages.frequencyData.shift')" class="handle-select mr10">
                        <el-option key :label="$t('pages.frequencyData.all')" value></el-option>
                        <el-option v-for="item in frequencyArr" :key="item.name" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.frequencyData.search')}}</el-button>
                </div>
            </div>
        </div>
        <!-- <div style="height: 100%; width: 100%"> -->
        <el-table :data="logRecords" border class="table" :height="tableHeight" style="overflow: auto">
            <el-table-column type="index" width="50" :label="$t('pages.frequencyData.index')"></el-table-column>
            <el-table-column sortable prop="date" :label="$t('pages.frequencyData.date')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }}
                </template>
            </el-table-column>
            <el-table-column prop="balanceId" :label="$t('pages.frequencyData.scaleId')"></el-table-column>
            <el-table-column :prop="isDisplayCompanyName ? 'fullBalanceName' : 'balanceName'" :label="$t('pages.frequencyData.scaleName')"></el-table-column>
            <el-table-column prop="frequency" :label="$t('pages.frequencyData.shiftCol')"></el-table-column>
            <el-table-column :label="$t('pages.frequencyData.freqWeight')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.freWeight }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
        <!-- </div> -->
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() == Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            tableHeight: window.innerHeight * 0.70,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            pageCount: 1,
            isDisplayCompanyName: false,
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                balanceId: 0,
                Frequency: '',
                PageIndex: 1,
                PageSize: 25
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        start.setTime(start.getTime() - 3600 * 1000);
        this.query.daterange = [start, end];
        this.getBalance();
        //this.getFrequencyData();
    },
    methods: {
        getData() {
            // if (this.query.balanceId == '') {
            //     this.$notify.warning('请选择秤!');
            //     return;
            // }

            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.frequencyData.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.query.CreateUserId = userInfo.id;
            this.query.UserName = userInfo.realName;
            this.$zybhttp
                .post('ProdInquiry/FrequencyData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                        this.pageCount = res.data.data.total || 0;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.frequencyData.yes') ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.frequencyData.fetchError')));
        },
        changeBalance() {
            if (this.query.balanceId == 0) {
                this.frequencyArr = [];
            } else {
                this.$zybhttp
                    .get('ProdInquiry/FreBalanceArr', {
                        params: {
                            balanceId: this.query.balanceId
                        }
                    })
                    .then((res) => {
                        if (res.data.status == 0) {
                            var d = res.data.data.list;
                            this.frequencyArr = d.sort(SortField('id', 'asc'));
                        } else {
                            this.$notify.error(res.message);
                        }
                    })
                    .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
            }
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.frequencyData.yes') ? true : false;
                        this.balanceArr = [{
                            id: 0,
                            name: '全部',
                            fullName: '全部',
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getFrequencyData() {
            this.$zybhttp
                .post('Frequency/GetList', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.frequencyArr = d.sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.frequencyData.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.frequencyData.index'),
                        columnSize: `8%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.frequencyData.date'),
                        columnSize: `20%`
                    },
                    {
                        field: 'balanceId',
                        displayName: this.$t('pages.frequencyData.scaleId'),
                        columnSize: `10%`
                    },
                    {
                        field: this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName',
                        displayName: this.$t('pages.frequencyData.scaleName')
                    },
                    {
                        field: 'frequency',
                        displayName: this.$t('pages.frequencyData.shiftCol'),
                        columnSize: `10%`
                    },
                    {
                        field: 'freWeight',
                        displayName: this.$t('pages.frequencyData.freqWeight'),
                        columnSize: `10%`
                    }
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:center;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.frequencyData.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
